import React, { PureComponent, ReactElement } from 'react';

import { ImageAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, expression, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames } from '@philips-emr/tws-utils';

import { Loader, withRouterContext } from '..';

import './image.scss';

export interface ImageProps {
  alt: string;
  className?: string;
  height?: string;
  loading?: boolean;
  maxHeight?: string;
  maxWidth?: string;
  minHeight?: string;
  minWidth?: string;
  src: string;
  uuid?: string;
  visible?: boolean;
  width?: string;
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: ImageAPI })
class Image extends PureComponent<ImageProps> {

  static propTypes = {
    alt: expression,
    className: string,
    height: string.group('size'),
    loading: bool,
    maxHeight: string.group('size'),
    maxWidth: string.group('size'),
    minHeight: string.group('size'),
    minWidth: string.group('size'),
    src: string,
    uuid: string,
    visible: bool,
    width: string.group('size'),
  };

  static defaultProps = {
    height: 'auto',
    visible: true,
    width: '100%',
  };

  getClassName(): string {
    const { className } = this.props;

    return classNames({
      'c-image': true,
      [`${className}`]: Boolean(className),
    });
  }

  render(): ReactElement | null {
    const { alt, height, loading, maxHeight, maxWidth, minHeight, minWidth, src, visible, width } = this.props;

    if (!visible || !src) {
      return null;
    }

    // TODO: migrate withRouterContext to avoid using typings like this;
    const imageComponent = ({ href }: { href: string }): ReactElement => {
      return (
        <img
          alt={msg(alt)}
          className={this.getClassName()}
          src={href}
          style={{ height, maxHeight, maxWidth, minHeight, minWidth, width }}
        />
      );
    };

    const ImageElement = withRouterContext(imageComponent, src);

    return (
      loading
        ? <Loader size={64} />
        : <ImageElement />
    );
  }
}

export default Image;
